var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.13308V7.84754L4.8814 8.79524C4.42472 9.29351 3.75335 9.61111 3 9.61111C1.60132 9.61111 0.5 8.52393 0.5 7.22222C0.5 5.92052 1.60132 4.83333 3 4.83333C3.11963 4.83333 3.23706 4.84134 3.35175 4.85674L4.39765 4.99722L3.84395 4.09885C3.62495 3.74352 3.5 3.33047 3.5 2.88889C3.5 1.58716 4.60131 0.5 6 0.5C7.39871 0.5 8.5 1.58715 8.5 2.88889C8.5 3.33049 8.37506 3.74354 8.15607 4.09885L7.60237 4.99726L8.6483 4.85674C8.76293 4.84134 8.88034 4.83333 9 4.83333C10.3987 4.83333 11.5 5.92051 11.5 7.22222C11.5 8.52393 10.3987 9.61111 9 9.61111C8.24665 9.61111 7.57528 9.29351 7.1186 8.79524L6.25 7.84754V9.13308V11.5556V12.0556H6.75H7.5C7.65604 12.0556 7.75 12.1727 7.75 12.2778C7.75 12.3829 7.65604 12.5 7.5 12.5H4.5C4.34397 12.5 4.25 12.3829 4.25 12.2778C4.25 12.1727 4.34397 12.0556 4.5 12.0556H5.25H5.75V11.5556V9.13308Z",
    stroke: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4);
export default __webpack_public_path__ + "static/media/c4.19d7b4ab7659f071b61931b589bb3c16.svg";
export { ForwardRef as ReactComponent };